export default "__VITE_ASSET__yLofRkPT__"